export default "__VITE_ASSET__97e15c13__"